import React from "react";

export const Partners = (props) => {
  const imageBasePath = "/img/";
  return (
    <div id="partner" style={styles.container}>
      <div style={styles.servicesGrid}>
        {props.data && props.data.items
          ? props.data.items.map((d, i) => (
              <div
                key={`${d.name}-${i}`}
                style={{
                  ...styles.serviceItem,
                  ...(window.innerWidth <= 768
                    ? styles.serviceItemSmall
                    : window.innerWidth <= 1024
                    ? styles.serviceItemMedium
                    : {}),
                }}
              >
               
               <img
                  src={`${imageBasePath}${d.image}`}
                  alt={d.name}
                  style={styles.imgPartner}
                />
                
              </div>
            ))
          : "loading..."}
      </div>
    </div>
  );
};

const styles = {
    imgPartner:{
        width: "100%"
    },
  container: {
    textAlign: "center",
    padding: "0px",
    backgroundColor: "#fff",
  },
  sectionTitle: {
    marginBottom: "40px",
  },
  servicesGrid: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "20px",
  },
  serviceItem: {
    flex: "1 1 calc(33.333% - 40px)", // Tres columnas en pantallas grandes
    maxWidth: "300px",
    textAlign: "center",
    backgroundColor: "#ffffff",
    padding: "0px",
    borderRadius: "10px",
  },
  serviceItemMedium: {
    flex: "1 1 calc(50% - 20px)", // Dos columnas en pantallas medianas
  },
  serviceItemSmall: {
    flex: "1 1 100%", // Una columna en pantallas pequeñas
  },
  iconContainer: {
    width: "80px",
    height: "80px",
    margin: "0 auto 20px",
    backgroundColor: "#ffffff",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
  },
  icon: {
    fontSize: "40px",
    color: "#1A9766",
  },
  serviceTitle: {
    fontSize: "18px",
    fontWeight: "600",
    marginBottom: "10px",
  },
  serviceText: {
    fontSize: "16px",
    color: "#7a7a7a",
  },
};
